import {
  getApiCaller,
  postFormDataApiCaller,
  putFormDataApiCaller,
  putApiCaller,
  deleteApiCaller,
} from "../apiCaller";

// Get all Bible books (admin panel)
export const getBible = async (page, limit, search, languageId = null) => {
  // Admin panel - optionally filter by language
  let url = `bible/books/admin?page=${page}&limit=${limit}&search=${search || ""}`;
  if (languageId) {
    url += `&language=${languageId}`;
  }
  const response = await getApiCaller(url);
  return response;
};

// Get books by language (public API)
export const getBooksByLanguage = async (languageId) => {
  const response = await getApiCaller(`bible/books?language=${languageId}`);
  return response;
};

// Get single book by code and language
export const getBookByCode = async (bookCode, languageId) => {
  const response = await getApiCaller(
    `bible/books/${bookCode}?language=${languageId}`
  );
  return response;
};

// Get chapter content
export const getChapter = async (languageId, bookCode, chapterNumber) => {
  const response = await getApiCaller(
    `bible/chapter?language=${languageId}&book=${bookCode}&chapter=${chapterNumber}`
  );
  return response;
};

// Admin: Add Bible book
export const addBible = async (payload) => {
  // Check if payload is already FormData
  if (payload instanceof FormData) {
    const response = await postFormDataApiCaller(`bible/create`, payload);
    return response;
  }

  // Convert payload to FormData
  const formData = new FormData();

  formData.append('title', payload.title || '');
  formData.append('content', payload.content || '');
  formData.append('language', payload.language || '');
  // Direction is now inherited from language, no need to send it

  if (payload.image) {
    formData.append('image', payload.image);
  }

  const response = await postFormDataApiCaller(`bible/create`, formData);
  return response;
};

// Admin: Update Bible book
export const updateBible = async (id, payload) => {
  // Check if payload is already FormData
  if (payload instanceof FormData) {
    const response = await putFormDataApiCaller(`bible/update/${id}`, payload);
    return response;
  }

  // Convert payload to FormData
  const formData = new FormData();

  formData.append('title', payload.title || '');
  formData.append('content', payload.content || '');
  formData.append('language', payload.language || '');
  // Direction is now inherited from language, no need to send it

  if (payload.image) {
    formData.append('image', payload.image);
  }

  const response = await putFormDataApiCaller(`bible/update/${id}`, formData);
  return response;
};

// Admin: Delete Bible book
export const deleteBible = async (id) => {
  const response = await deleteApiCaller(`bible/delete/${id}`);
  return response;
};

// Get single Bible book by ID (for admin panel - shows book + chapters)
export const getSingleBibleBook = async (id) => {
  const response = await getApiCaller(`bible/books/admin/${id}`);
  return response;
};

// Admin: Update Bible book sequence
export const updateBibleBookSequence = async (payload) => {
  const response = await putApiCaller("bible/sequence", payload);
  return response;
};

// Admin: Delete chapter audio
export const deleteChapterAudio = async (bookId, chapterNumber) => {
  const response = await deleteApiCaller(`bible/audio/${bookId}/${chapterNumber}`);
  return response;
};
